import React from 'react';
import MenuItems from "./MenuItems";
import {withRouter} from "../../utils/withRouter";
import { Link } from "react-router-dom";
import {checkPermission, isSystemScope} from "../../utils/common";
import WorkspaceController from "../../services/task/workspace-controller";
import './styles.css';
import "../../assets/css/core-kit.css";

/**
 * Sidebar desktop kiểu MISA ASP (Phase 2.5 — claude/DESIGN_SYSTEM.md):
 *  - MỘT danh sách dọc các phân hệ trên nền navy.
 *  - Thu gọn: chỉ icon. Mở rộng: icon + TÊN phân hệ (không bung con inline).
 *  - Submenu LUÔN hiện qua flyout khi hover/click vào phân hệ (đúng hành vi ASP);
 *    phân hệ không có menu con → điều hướng thẳng (tooltip khi thu gọn).
 *  - Ô tìm kiếm (khi mở rộng): lọc không dấu xuyên phân hệ, kết quả phẳng kèm nhãn phân hệ.
 * Props giữ nguyên khuôn cũ (activeClass, parentClass) — không trang nào phải sửa.
 */
class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            sidebarCollapsed: localStorage.getItem('sas_sidebar_collapsed') === 'true',
            searchText: '',
            flyout: null,           // {item, top, left} — submenu nổi khi hover phân hệ
            railTooltip: null,      // {text, top, left} — tooltip khi thu gọn (nhóm không có con)
            taskBadge: 0,           // badge đỏ "Công việc" (PRD workspace P1: poll /workspace/badge 60s)
        };
        this.flyoutTimer = null;
        this.badgeTimer = null;
    }

    componentDidMount() {
        this.initializeMenu();

        // Apply sidebar collapsed state on mount
        if (this.state.sidebarCollapsed) {
            document.getElementById('mainContainer')?.classList.add('sidebar-collapsed');
        }

        // Badge "Công việc": chỉ user có TSK0; poll 60s + refresh khi quay lại tab trình duyệt
        if (checkPermission('TSK0')) {
            this.loadTaskBadge();
            this.badgeTimer = setInterval(this.loadTaskBadge, 60000);
            window.addEventListener('focus', this.loadTaskBadge);
        }
    }

    componentWillUnmount() {
        if (this.flyoutTimer) clearTimeout(this.flyoutTimer);
        if (this.badgeTimer) clearInterval(this.badgeTimer);
        window.removeEventListener('focus', this.loadTaskBadge);
    }

    loadTaskBadge = () => {
        WorkspaceController.badge((res) => {
            if (res && res.success && res.data) {
                this.setState({taskBadge: res.data.total || 0});
            }
        });
    }

    renderTaskBadge = () => {
        const {taskBadge} = this.state;
        if (!taskBadge) return null;
        return (
            <span className="sas-filter-count" style={{background: 'var(--danger)', marginLeft: 6}}>
                {taskBadge > 99 ? '99+' : taskBadge}
            </span>
        );
    }

    /* Nhóm menu chứa trang hiện tại. Ưu tiên khớp URL (longest match trên url của
     * nhóm/mục con) vì các trang cũ vẫn truyền parentClass theo tên nhóm TRƯỚC khi
     * tái cấu trúc; nếu URL không khớp thì quy đổi parentClass cũ qua 'aliases'. */
    resolveParentClass = () => {
        const path = window.location.pathname;
        let best = null, bestLen = -1;
        for (const item of MenuItems.AdminSchool) {
            if (item.type === 'section') continue;
            const urls = [item.url, ...(item.children || []).map(c => c.url)];
            for (const url of urls) {
                if (!url) continue;
                // '/ad-sas-school' là prefix của MỌI url khác trong menu (base path của app)
                // — chỉ khớp tuyệt đối, không dùng startsWith, để tránh nuốt hết các trang khác.
                const matched = url === '/ad-sas-school' ? path === url : path.startsWith(url);
                if (matched && url.length > bestLen) {
                    best = item.activeClass;
                    bestLen = url.length;
                }
            }
        }
        if (best) return best;

        const { parentClass } = this.props;
        if (!parentClass) return null;
        for (const item of MenuItems.AdminSchool) {
            if (item.type === 'section') continue;
            if (item.activeClass === parentClass || (item.aliases || []).includes(parentClass)) {
                return item.activeClass;
            }
        }
        return parentClass;
    }

    initializeMenu = () => {
        let allMenuItems = JSON.parse(JSON.stringify(MenuItems.AdminSchool));

        for (let i = 0; i < allMenuItems.length; i++) {
            let item = allMenuItems[i];
            if (item.type === 'section') continue;

            // `systemOnly` = man hinh LIEN TRUONG (bao cao he thong): ma quyen mot minh khong du
            // vi quyen do cung duoc cap cho hieu truong tung truong => them dieu kien pham vi he
            // thong (JWT schoolid < 0). Menu an trung voi route da gate cung dieu kien, khong
            // bao gio co canh "thay menu nhung bam vao 403".
            if (item.systemOnly && !isSystemScope()) {
                item.isShow = false;
                (item.children || []).forEach((c) => {
                    if (c.type !== 'section') c.isShow = false;
                });
                continue;
            }

            // `schoolOnly` = NGHICH DAO cua `systemOnly`: man hinh chi co nghia TRONG MOT TRUONG,
            // an voi admin tong (SCR-079: "Admin tong khong quan ly chi tiet tung truong").
            // Can co vi mot so ma quyen admin tong BUOC phai giu cho man cap he thong dung chung
            // guard: vd SFM0 (SERVICE_FORM|VIEW) vua gac "Form dang ky dich vu" cua truong vua gac
            // "Domain form dang ky" lien truong => thu hoi quyen la chet man he thong, nen phai an
            // bang co pham vi thay vi bang quyen.
            if (item.schoolOnly && isSystemScope()) {
                item.isShow = false;
                (item.children || []).forEach((c) => {
                    if (c.type !== 'section') c.isShow = false;
                });
                continue;
            }

            if (item.permission === '*') {
                // Sentinel: hiện với mọi tài khoản đăng nhập, không gate theo quyền
                item.isShow = true;
            } else {
                let permissionArr = item.permission.split("|");
                let isShow = false;

                for (let i1 = 0; i1 < permissionArr.length; i1++) {
                    isShow = checkPermission(permissionArr[i1]);
                    if (isShow) break;
                }
                item.isShow = isShow;
            }

            let children = item.children;
            if (children) {
                for (let y = 0; y < children.length; y++) {
                    // Dải phân cách không phải mục bấm được nên không khai `permission`;
                    // đọc tiếp là .split() của undefined làm hỏng cả sidebar.
                    if (children[y].type === 'section') continue;
                    if (children[y].systemOnly && !isSystemScope()) {
                        children[y].isShow = false;
                        continue;
                    }
                    if (children[y].schoolOnly && isSystemScope()) {
                        children[y].isShow = false;
                        continue;
                    }
                    let childPermissionArr = children[y].permission.split("|");
                    let childIsShow = false;

                    for (let y1 = 0; y1 < childPermissionArr.length; y1++) {
                        childIsShow = checkPermission(childPermissionArr[y1]);
                        if (childIsShow) break;
                    }
                    children[y].isShow = childIsShow;
                }
            }
        }

        this.setState({ items: allMenuItems });
    }

    getVisibleChildrenCount = (children) => {
        if (!children) return 0;
        return children.filter(child => child.type !== 'section' && child.isShow).length;
    }

    /**
     * Danh sách con để HIỂN THỊ — giữ cả dải phân cách, nhưng bỏ dải nào không còn mục nào
     * đứng sau: quyền cắt sạch một nhóm mà tiêu đề nhóm vẫn nằm đó thì người dùng tưởng
     * menu hỏng. Cùng luật với dải phân cách ở menu cấp 1.
     */
    getRenderableChildren = (children) => {
        const shown = (children || []).filter(c => c.type === 'section' || c.isShow);
        return shown.filter((c, i) => c.type !== 'section'
            || (shown[i + 1] && shown[i + 1].type !== 'section'));
    }

    /* --- Tìm kiếm menu — khớp không phân biệt hoa thường & dấu tiếng Việt --- */
    normalizeText = (s) => (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd');

    /* Bôi vàng phần khớp (chỉ khi khớp nguyên văn; khớp kiểu bỏ dấu thì giữ nguyên chữ) */
    highlightMatch = (text) => {
        const q = this.state.searchText.trim();
        if (!q) return text;
        const idx = text.toLowerCase().indexOf(q.toLowerCase());
        if (idx < 0) return text;
        return (
            <>
                {text.slice(0, idx)}
                <span className="sidebar-highlight">{text.slice(idx, idx + q.length)}</span>
                {text.slice(idx + q.length)}
            </>
        );
    }

    /* Kết quả tìm kiếm phẳng xuyên mọi phân hệ: [{group, child|null}] */
    getSearchResults = () => {
        const {items, searchText} = this.state;
        const q = searchText.trim();
        if (!q) return null;
        const nq = this.normalizeText(q);
        const match = (t) => this.normalizeText(t).includes(nq);
        const results = [];
        for (const item of items) {
            if (item.type === 'section' || !item.isShow) continue;
            const titleMatch = match(item.title);
            if (item.children && item.children.length > 0) {
                for (const c of item.children) {
                    if (c.isShow && (titleMatch || match(c.title))) results.push({group: item, child: c});
                }
            } else if (titleMatch) {
                results.push({group: item, child: null});
            }
        }
        return results;
    }

    /* --- Flyout / tooltip khi hover phân hệ --- */
    openFlyout = (e, item) => {
        this.cancelHide();
        const rect = e.currentTarget.getBoundingClientRect();
        const left = rect.right + 6;
        if (this.getVisibleChildrenCount(item.children) > 0) {
            // Clamp đáy màn hình để panel không tràn
            const top = Math.min(rect.top, Math.max(12, window.innerHeight - 360));
            this.setState({flyout: {item, top, left}, railTooltip: null});
        } else if (this.state.sidebarCollapsed) {
            // Thu gọn mới cần tooltip; mở rộng đã thấy tên
            this.setState({
                railTooltip: {text: item.title, top: rect.top + rect.height / 2, left},
                flyout: null,
            });
        } else {
            this.setState({flyout: null, railTooltip: null});
        }
    }

    showToggleTooltip = (e, text) => {
        this.cancelHide();
        const rect = e.currentTarget.getBoundingClientRect();
        this.setState({
            railTooltip: {text, top: rect.top + rect.height / 2, left: rect.right + 6},
            flyout: null,
        });
    }

    scheduleHide = () => {
        this.cancelHide();
        this.flyoutTimer = setTimeout(() => this.setState({flyout: null, railTooltip: null}), 160);
    }

    cancelHide = () => {
        if (this.flyoutTimer) {
            clearTimeout(this.flyoutTimer);
            this.flyoutTimer = null;
        }
    }

    toggleSidebar = () => {
        const newState = !this.state.sidebarCollapsed;
        this.setState({ sidebarCollapsed: newState, railTooltip: null, flyout: null, searchText: '' });
        localStorage.setItem('sas_sidebar_collapsed', newState.toString());

        const mainContainer = document.getElementById('mainContainer');
        if (mainContainer) {
            if (newState) {
                mainContainer.classList.add('sidebar-collapsed');
            } else {
                mainContainer.classList.remove('sidebar-collapsed');
            }
        }
    }

    render() {
        const { activeClass } = this.props;
        const { sidebarCollapsed, searchText, flyout, railTooltip } = this.state;
        const { items } = this.state;
        const resolvedParent = this.resolveParentClass();

        // Section đi kèm nhóm phía sau nó: cả cụm bị ẩn theo quyền thì ẩn luôn section
        const shown = items.filter(item => item.type === 'section' || item.isShow);
        const visibleItems = shown.filter((item, i) =>
            item.type !== 'section' || (shown[i + 1] && shown[i + 1].type !== 'section')
        );
        const searchResults = this.getSearchResults();

        return (
            <div className={`col-md-2 p-0 pr-3 sidebar-column ${sidebarCollapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-wrapper sidebar-asp">
                    {/* Tìm kiếm — chỉ khi mở rộng */}
                    {!sidebarCollapsed && (
                        <div className="sidebar-search">
                            <div className="sas-searchbox" style={{width: '100%'}}>
                                <i className="fas fa-search"></i>
                                <input
                                    type="text"
                                    value={searchText}
                                    placeholder="Tìm chức năng..."
                                    onChange={(e) => this.setState({searchText: e.target.value})}
                                />
                                {!!searchText && (
                                    <button type="button" className="sas-searchbox-clear" title="Xóa" tabIndex={-1}
                                            onClick={() => this.setState({searchText: ''})}>
                                        ×
                                    </button>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Danh sách phân hệ (icon; mở rộng thêm tên) hoặc kết quả tìm kiếm */}
                    {!sidebarCollapsed && searchResults ? (
                        searchResults.length === 0 ? (
                            <div className="sidebar-search-empty">Không tìm thấy chức năng phù hợp</div>
                        ) : (
                            <ul className="sidebar-asp-menu">
                                {searchResults.map((r, i) => {
                                    const target = r.child || r.group;
                                    return (
                                        <li key={i}>
                                            <Link
                                                to={target.url || '#'}
                                                className={`sidebar-asp-result ${activeClass === target.activeClass ? 'active' : ''}`}
                                                onClick={() => this.setState({searchText: ''})}
                                            >
                                                <span className="sidebar-asp-result-group">{r.group.title}</span>
                                                <span>{this.highlightMatch(target.title)}</span>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        )
                    ) : (
                        <ul className="sidebar-asp-menu" onMouseLeave={this.scheduleHide}>
                            {visibleItems.map((item, index) => {
                                if (item.type === 'section') {
                                    return sidebarCollapsed
                                        ? <li key={index} className="sidebar-asp-divider"/>
                                        : <li key={index} className="sidebar-asp-section"><span>{item.title}</span></li>;
                                }
                                const isActive = resolvedParent === item.activeClass || activeClass === item.activeClass;
                                const iconClass = item.icon.replace('font-18 icon-side-bar', '');
                                const hasChildren = this.getVisibleChildrenCount(item.children) > 0;
                                const cls = `sidebar-asp-item ${isActive ? 'active' : ''}`;
                                return (
                                    <li key={index}>
                                        {hasChildren ? (
                                            <button
                                                type="button"
                                                className={cls}
                                                aria-label={item.title}
                                                onMouseEnter={(e) => this.openFlyout(e, item)}
                                                onClick={(e) => this.openFlyout(e, item)}
                                            >
                                                <i className={`${iconClass} sidebar-asp-icon`}></i>
                                                <span className="sidebar-asp-text">{item.title}</span>
                                                {item.activeClass === 'my-work' && this.renderTaskBadge()}
                                                <i className="fas fa-chevron-right sidebar-asp-arrow"></i>
                                            </button>
                                        ) : (
                                            <Link
                                                to={item.url || '#'}
                                                className={cls}
                                                aria-label={item.title}
                                                onMouseEnter={(e) => this.openFlyout(e, item)}
                                            >
                                                <i className={`${iconClass} sidebar-asp-icon`}></i>
                                                <span className="sidebar-asp-text">{item.title}</span>
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    )}

                    {/* Nút thu gọn/mở rộng — chân sidebar */}
                    <button
                        className="sidebar-asp-toggle"
                        type="button"
                        aria-label={sidebarCollapsed ? 'Mở rộng menu' : 'Thu gọn menu'}
                        onMouseEnter={(e) => sidebarCollapsed && this.showToggleTooltip(e, 'Mở rộng menu')}
                        onMouseLeave={this.scheduleHide}
                        onClick={this.toggleSidebar}
                    >
                        <i className={`fas fa-chevron-${sidebarCollapsed ? 'right' : 'left'}`}></i>
                        <span className="sidebar-asp-text">Thu gọn</span>
                    </button>
                </div>

                {/* Flyout submenu khi hover phân hệ (kiểu MISA ASP) */}
                {flyout && (
                    <div
                        className="sidebar-flyout"
                        style={{top: flyout.top, left: flyout.left}}
                        onMouseEnter={this.cancelHide}
                        onMouseLeave={this.scheduleHide}
                    >
                        <div className="sidebar-flyout-title">
                            <i className={flyout.item.icon.replace('font-18 icon-side-bar', '')}></i>
                            <span>{flyout.item.title}</span>
                        </div>
                        <ul className="sidebar-flyout-menu">
                            {this.getRenderableChildren(flyout.item.children).map((child, i) => (
                                child.type === 'section' ? (
                                    <li key={i} className="sidebar-flyout-section"><span>{child.title}</span></li>
                                ) : (
                                    <li key={i}>
                                        <Link
                                            to={child.url}
                                            className={`sidebar-flyout-link ${activeClass === child.activeClass ? 'active' : ''}`}
                                            onClick={() => this.setState({flyout: null})}
                                        >
                                            {child.title}
                                            {child.activeClass === 'task-workspace' && this.renderTaskBadge()}
                                        </Link>
                                    </li>
                                )
                            ))}
                        </ul>
                    </div>
                )}

                {/* Tooltip khi thu gọn */}
                {railTooltip && !flyout && (
                    <div className="sidebar-rail-tooltip" style={{top: railTooltip.top, left: railTooltip.left}}>
                        {railTooltip.text}
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(Sidebar);
